// Template: resources/views/site/trial.blade.php

export default {

    name: "TrialPage",

    data() {
        return {
            buttonHovered: false
        }
    }
};
